import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { ErrorBoundary } from '@/components/ErrorBoundary';

// Public pages
import HomePage from '@/pages/HomePage';
import WorkPage from '@/pages/WorkPage';
import FrameworkDetailPage from '@/pages/FrameworkDetailPage';
import OracleDeckPage from '@/pages/OracleDeckPage';
import EssaysPage from '@/pages/EssaysPage';
import EssayDetailPage from '@/pages/EssayDetailPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import CheckoutSuccessPage from '@/pages/CheckoutSuccessPage';
import NotFoundPage from '@/pages/NotFoundPage';
import LegalPage from '@/pages/LegalPage';
import IdeaClarityPage from '@/pages/IdeaClarityPage';
import SacredFeminineQuizPage from '@/pages/SacredFeminineQuizPage';
import SacredFeminineFrameworkPage from '@/pages/SacredFeminineFrameworkPage';
import FoundationsPage from '@/pages/FoundationsPage';
import GuidancePage from '@/pages/GuidancePage';
import InstrumentsPage from '@/pages/InstrumentsPage';
import PlannerPage from '@/pages/PlannerPage';
import LinksPage from '@/pages/LinksPage';

// Admin pages
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminEssays from '@/pages/admin/AdminEssays';
import AdminFrameworks from '@/pages/admin/AdminFrameworks';
import AdminProducts from '@/pages/admin/AdminProducts';
import AdminPages from '@/pages/admin/AdminPageBuilder';
import AdminWaitlist from '@/pages/admin/AdminWaitlist';
import AdminOrders from '@/pages/admin/AdminOrders';
import AdminContacts from '@/pages/admin/AdminContacts';
import AdminAuditLog from '@/pages/admin/AdminAuditLog';
import AdminSettings from '@/pages/admin/AdminSettings';
import AdminMedia from '@/pages/admin/AdminMedia';
import AdminLinks from '@/pages/admin/AdminLinks';

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-[hsl(164,28%,14%)]">
        <div className="noise-overlay" />
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/work" element={<WorkPage />} />
            <Route path="/work/:slug" element={<FrameworkDetailPage />} />
            <Route path="/oracle-deck" element={<OracleDeckPage />} />
            <Route path="/essays" element={<EssaysPage />} />
            <Route path="/essays/:slug" element={<EssayDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/idea-clarity-session" element={<IdeaClarityPage />} />
            <Route path="/sacred-feminine-quiz" element={<SacredFeminineQuizPage />} />
            <Route path="/sacred-feminine-archetypes" element={<SacredFeminineFrameworkPage />} />
            <Route path="/foundations" element={<FoundationsPage />} />
            <Route path="/guidance" element={<GuidancePage />} />
            <Route path="/instruments" element={<InstrumentsPage />} />
            <Route path="/planner" element={<PlannerPage />} />
            <Route path="/links" element={<LinksPage />} />

            {/* Legal Pages — Replace termlyId with your Termly embed UUIDs */}
            <Route path="/privacy" element={<LegalPage title="Privacy Policy" termlyId="" />} />
            <Route path="/cookies" element={<LegalPage title="Cookies Policy" termlyId="" />} />
            <Route path="/terms" element={<LegalPage title="Terms of Service" termlyId="" />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/essays" element={<AdminEssays />} />
            <Route path="/admin/frameworks" element={<AdminFrameworks />} />
            <Route path="/admin/products" element={<AdminProducts />} />
            <Route path="/admin/pages" element={<AdminPages />} />
            <Route path="/admin/waitlist" element={<AdminWaitlist />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/contacts" element={<AdminContacts />} />
            <Route path="/admin/audit-log" element={<AdminAuditLog />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/media" element={<AdminMedia />} />
          <Route path="/admin/links" element={<AdminLinks />} />

            {/* 404 Catch-all */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: 'hsl(166, 25%, 12%)',
              border: '1px solid rgba(201, 168, 76, 0.25)',
              color: 'hsl(168, 18%, 92%)',
              fontFamily: 'Inter, sans-serif'
            }
          }}
        />
      </div>
    </ErrorBoundary>
  );
}

export default App;
